import React from 'react'
import { Box, Text, Tooltip } from '@chakra-ui/react'

interface CollapsibleListProps {
  items: string[]
  maxItems?: number
}

const CollapsibleList: React.FC<CollapsibleListProps> = ({
  items,
  maxItems = 4,
}) => {
  if (!items || items.length === 0) return <Text>-</Text>

  const displayItems = items.slice(0, maxItems)
  const remainingCount = items.length - maxItems
  const remainingItems = items.slice(maxItems)

  return (
    <Box>
      <Text noOfLines={2}>
        {displayItems.join(', ')}
        {remainingCount > 0 && (
          <Tooltip label={remainingItems.join(', ')} hasArrow placement="top">
            <Text as="span" color="blue.500" cursor="help" ml={1}>
              (+{remainingCount} more)
            </Text>
          </Tooltip>
        )}
      </Text>
    </Box>
  )
}

export default CollapsibleList

